import { render, staticRenderFns } from "./ModalHabilitacaoEncerrada.vue?vue&type=template&id=8a1872b2&scoped=true"
import script from "./ModalHabilitacaoEncerrada.vue?vue&type=script&lang=js"
export * from "./ModalHabilitacaoEncerrada.vue?vue&type=script&lang=js"
import style0 from "./ModalHabilitacaoEncerrada.vue?vue&type=style&index=0&id=8a1872b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1872b2",
  null
  
)

export default component.exports